// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-item-menu_container-ev26F {
  min-width: 220px;
}

.product-item-deleteOption_text-SOrvG {
  color: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/product-item/product-item.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".menu_container {\n  min-width: 220px;\n}\n\n.deleteOption_text {\n  color: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu_container": `product-item-menu_container-ev26F`,
	"deleteOption_text": `product-item-deleteOption_text-SOrvG`
};
export default ___CSS_LOADER_EXPORT___;
